import { type PropsWithChildren } from 'react'

import { cn } from 'utils/cn'

export const Mark = ({
  isOnKarnovNote = true,
  children,
}: PropsWithChildren<{ isOnKarnovNote: boolean }>) => (
  <mark className={cn('rounded-sm', {
    'bg-sourcehighlight-on-bg-karnovnote': isOnKarnovNote,
    'bg-sourcehighlight': !isOnKarnovNote,
  })}
  >
    {children}
  </mark>
)
